import { render } from "./App.vue?vue&type=template&id=eb90eaea"
const script = {}

import exportComponent from "/root/workspace/ayaey-web-home_efv7/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__